const statusSiteUserPublisher = {
  PENDING: 1,
  CONFIRM: 2,
  REJECT: 3,
};

const getStatusSiteUserPublisherString = () => {
  let data = {};
  data[statusSiteUserPublisher.PENDING] = "در حال انتظار";
  data[statusSiteUserPublisher.CONFIRM] = "تایید شده";
  data[statusSiteUserPublisher.REJECT] = "رد شده";

  return data;
};

const activeSiteUserPublisher = {
  ACTIVE: true,
  DEACTIVATE: false,
};

const getActiveSiteUserPublisherString = () => {
  let data = {};
  data[activeSiteUserPublisher.ACTIVE] = "فعال";
  data[activeSiteUserPublisher.DEACTIVATE] = "غیرفعال";

  return data;
};

export default {
  statusSiteUserPublisher,
  getStatusSiteUserPublisherString,
  activeSiteUserPublisher,
  getActiveSiteUserPublisherString,
};
